import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-calendar';
import { renderToStaticMarkup } from 'react-dom/server';
import { useModal } from '../../../../../services/customHooks';
import AvailabilityEvent from './AvailabilityEvent';
import RemoveAvailabilityModal from './RemoveAvailabilityModal';
import Form from '../../../../../commonComponents/forms/Form';
import FormInput from '../../../../../commonComponents/forms/FormInput';
import List from '../../../../../commonComponents/lists/ClientSideList';
import FormFooter from '../../../../../commonComponents/forms/FormFooter';
import userProp from '../../../../../commonComponents/propTypes/userProp';
import translate from '../../../../../commonComponents/translate';

function TabAvailability({ t, userTrainer, onMemberChange }) {
  const [state, setState] = useState(userTrainer?.trainer?.availability || []);

    // Preforms changes in userTrainer State
  const handleChangeAvailability = params => {
    setState(prevState => {
      const trainerAux = { ...prevState.trainer, ...params.trainer };
      return { ...prevState, ...params, trainer: trainerAux };
    });
  };
  const tableId = 'availability-list';
  const [indexAvailability, setIndexAvailability] = useState(-1);
  const [removeModal, showRemoveModal] = useModal({ show: false });
  const tableEl = useRef(null);

  // State for one item
  const [availability, setAvailability] = useState({
    status: '',
    startDate: '',
    endDate: '',
  });

  const validationRules = {
    status: { required: true },
    startDate: { required: true },
    endDate: { required: true },
  };

  // List Column
  const columns = [
    {
      field: '',
      title: '',
      textAlign: 'center',
      sortable: false,
      template: (item, index) => renderToStaticMarkup(
        <AvailabilityEvent
          t={t}
          availability={item}
          index={index}
        />,
      ),
    },
  ];

  // Available or Unavailable Options in select
  const availabilityOptions = [
    {
      id: 'unavailable',
      text: t('unavailable'),
    },
    {
      id: 'available',
      text: t('available'),
    },
  ];

  // State for showing range in Calendar
  const [dateState, setDateState] = useState(new Date());

  // Adding date
  const onChange = date => {
    // Set Date Range in Calendar
    setDateState(date);
    // Setting the start date and end date in calendar
    setAvailability(prevState => {
      const params = {
        startDate: date[0].getTime(),
        endDate: date[1].getTime(),
      };
      return { ...prevState, ...params };
    });
  };

  const handleRemove = index => {
    showRemoveModal({ show: false, index: null });
    tableEl.current.removeListItem(index);
  };

  // handling add and edit an item a new item to the list
  const editHandler = index => {
    setIndexAvailability(index);
    setAvailability(tableEl.current.getListItem(index));
  };

  const handleAddAndEdit = () => {
    if (indexAvailability === -1) {
      tableEl.current.addListItem(availability);
    } else {
      tableEl.current.updateListItem(indexAvailability, availability);
      setIndexAvailability(-1);
    }
  };

  // Update availability Status
  const handleChange = field => value =>
    setAvailability(prevState => ({ ...prevState, [field]: value }));

  function handleListInitialization() {
    $(`#${tableId}`)
      .on('click', '.edit-availability', function edit() {
        const indexEvent = $(this).attr('data-availability-index');
        editHandler(indexEvent);
      })
      .on('click', '.remove-availability', function edit() {
        const indexEvent = $(this).attr('data-availability-index');
        showRemoveModal({ show: true, index: indexEvent });
      });
  }

  const handleRemoveModalClose = () => {
    showRemoveModal({ show: false, index: null });
  };

  const handleSubmit = async () => {
    const params = {
      availability: state.trainer.availability,
    };
    onMemberChange(params, 'trainer');
  };

  return (
    <>
      {removeModal.show && (
        <RemoveAvailabilityModal
          onRemove={handleRemove}
          index={removeModal.index}
          onClose={handleRemoveModalClose}
        />
      )}
      <div>
        <Form
          className="form-horizontal"
          id="trainerAvailabilityForm"
          submitMethod={handleAddAndEdit}
          validationRules={validationRules}
        >
          {submitHandler => (
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
                <span className="trainers-tab_title">{t('trainers.edit.availability')}</span>
                <div className="calendar-container">
                  <Calendar onChange={onChange} value={dateState} returnValue="range" selectRange locale="en-US" />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12 availability-container">
                <h6 className="date-selected">
                  {t('trainers.edit.selectData')}
                </h6>
                <FormInput
                  id="status"
                  name="status"
                  value={availability.status}
                  onChange={handleChange('status')}
                  label={t('trainers.edit.availability')}
                  labelClassName="col-3 text-right label-availability"
                  containerClassName="col-8 remove-padding"
                  type="select"
                  placeholder={t('trainers.edit.availability')}
                  inputClassName={availabilityOptions.id}
                  groupProps={{ className: 'row' }}
                  inputProps={{
                    width: '100%',
                    multiple: false,
                    items: availabilityOptions.map(c => ({ id: c.id, text: c.text })),
                  }}
                />
                <div className="date-picker_availability">
                  <FormInput
                    id="startDate"
                    name="startDate"
                    value={availability.startDate}
                    onChange={handleChange('startDate')}
                    label={t('trainers.edit.startDate')}
                    labelClassName="col-3 text-right label-availability"
                    containerClassName="col-8 remove-padding"
                    type="dateTime"
                    placeholder={t('trainers.edit.startDate')}
                    groupProps={{ className: 'row' }}
                  />
                  <FormInput
                    id="endDate"
                    name="endDate"
                    value={availability.endDate}
                    onChange={handleChange('endDate')}
                    label={t('trainers.edit.endDate')}
                    labelClassName="col-3 text-right label-availability"
                    containerClassName="col-8 remove-padding"
                    type="dateTime"
                    placeholder={t('trainers.edit.endDate')}
                    groupProps={{ className: 'row' }}
                  />
                </div>
                <div className="">
                  <button
                    type="button"
                    className="btn btn-dynamic m-btn m-btn--custom add-availability-button col-lg-4 col-md-4 col-4"
                    onClick={submitHandler}
                  >
                    {indexAvailability === -1 ? t('add') : t('save')}
                  </button>
                </div>
              </div>
              <div className="col-lg-12 col-12">
                <List
                  ref={tableEl}
                  loading={false}
                  data={userTrainer?.trainer?.availability || []}
                  id={tableId}
                  columns={columns}
                  onInit={handleListInitialization}
                  onDataUpdated={list => {
                    handleChangeAvailability({ trainer: { availability: list } });
                  }}
                />
              </div>
            </div>
          )}
        </Form>
      </div>
      <div id="footer-submit-availability">
        <FormFooter submitHandler={handleSubmit} />
      </div>
    </>
  );
}

TabAvailability.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  userTrainer: PropTypes.shape(userProp.propType).isRequired,
  onMemberChange: PropTypes.func.isRequired,
};

export default translate(TabAvailability);
